import * as PopoverPrimitive from '@radix-ui/react-popover'
import { useContainer } from '@tldraw/editor'
import { memo } from 'react'
import { MenuChild, useActionsMenuSchema, useReadonly, useTranslation } from '../../hooks'
import { Button, kbdStr } from '../primitives'
import { Popover, PopoverTrigger } from '../primitives/Popover'

export const ActionsMenu = memo(function ActionsMenu() {
	const msg = useTranslation()
	const container = useContainer()
	const menuSchema = useActionsMenuSchema()
	const isReadonly = useReadonly()

	function getActionMenuItem(item: MenuChild) {
		if (isReadonly && !item.readonlyOk) return null

		switch (item.type) {
			case 'item': {
				const { id, icon, label, kbd, onSelect } = item.actionItem

				return (
					<Button
						key={id}
						className="tlui-button-grid__button"
						data-wd={`menu-item.${item.id}`}
						icon={icon}
						title={
							label
								? kbd
									? `${msg(label)} ${kbdStr(kbd)}`
									: `${msg(label)}`
								: kbd
								? `${kbdStr(kbd)}`
								: ''
						}
						onClick={onSelect}
						disabled={item.disabled}
					/>
				)
			}
		}
	}

	return (
		<Popover id="actions menu">
			<PopoverTrigger>
				<Button
					className="tlui-menu__trigger"
					data-wd="main.action-menu"
					icon="dots-vertical"
					title={msg('actions-menu.title')}
					smallIcon
				/>
			</PopoverTrigger>
			<PopoverPrimitive.Portal dir="ltr" container={container}>
				<PopoverPrimitive.Content
					className="tlui-popover__content"
					side="bottom"
					dir="ltr"
					sideOffset={6}
				>
					<div className="tlui-actions-menu tlui-button-grid__four">
						{menuSchema.map(getActionMenuItem)}
					</div>
				</PopoverPrimitive.Content>
			</PopoverPrimitive.Portal>
		</Popover>
	)
})
